export default function (name: string, maxchar = 20): string {
  if (name && name.length > maxchar) {
    return `${name.substring(0, maxchar)}&#8230;`
  }
  return name
}
